import React, { useState } from 'react';

import '../css/faq.css';

const faqData = {
  en:{
    'Health, Hygiene, Security and Safety': [
      'What should I know about pollution in Indian cities?',
      'How can I adapt to extreme weather conditions in India (heat, monsoons, winters)?',
      'What are the common ailments newcomers to India should be aware about? What are the recommended prevention techniques.',
      'What vaccinations are recommended prior to moving to India?',
      'How is the healthcare system in India?',
      'Are medical facilities in India reliable?',
      'What measures should be taken in case of a medical emergency at home?',
      'Should one get health insurance before moving to India?',
      'Are Pharmacies easily available?',
      'Is tap water considered safe to drink in India?',
      'Are gyms and fitness centers widely available?',
      'How can I maintain mental well-being in a new environment?',
      'How hygienic are public washroom facilities in India?',
      'What are the various safety issues on Indian roads and how to deal with them?',
      'How to ensure Home Security?',
      'How to select and manage household Help?',
      'What to be aware about with your Neighbourhood Security?',
      'How to deal with Handymen and other service providers?',
      'How to manage language barriers when interacting with vendors and handymen?',
    ],
    'Finding a Home': [
      'What are the resources available to find a home in India.',
      'How to select a reliable housing broker.',
      'What commissions are to be paid to housing brokers',
      'Are online real estate listings and resources reliable?',
      'What are the main responsibilities of an Indian Landlord?',
      'What are the main responsibilities of a tenant?',
      'What are the main lease terms in India?',
      'What is the monthly cost of renting a home in India?',
      'What are the taxes against lease and how are they paid?',
      'Can the security deposit be paid from overseas?',
      'Is it easy to secure the refund of a security deposit?',
      'What are the preferred communities for foreigners in Bengaluru?',
      'What are the preferred communities for foreigners in Mumbai?',
      'What are the preferred communities for foreigners in Delhi?',
      'What are the preferred communities for foreigners in Gurugram?',
      'What are the preferred communities for foreigners in Chennai?',
      'What are the preferred communities for foreigners in Hyderabad?',
      'What are the preferred communities for foreigners in Pune?',
    ],
    'Work permit, Visa and other compliances': [
      'Do I need a work permit to be able to work in India?',
      'How long does it take to secure permission to work in India?',
      'What documents and requirements are to be fulfilled to work in India?',
      'Do I need a residential permit to be able to live in India?',
      'Will my family members be able to live with me in India?',
      'How long would the India Employment Visa be valid for?',
      'How does one extend an Indian work and residential permit.',
      'What documents are required to extend by work permit.',
    ],
    'Home Management tips': [
      'What are the main issues faced while managing a home in India?',
      'Some tips for managing a home in India?',
      'How do utilities work in India?',
      'How to pay for utility bills',
      'How does the Garbage disposal service work in India?',
      'How to manage pest control at home?',
      'What are the typical tenant responsibilities?',
      'What should I know about voltage and electrical systems in India?',
    ],
    'Travel and Transportation': [
      'Is Public transport system well established in India?',
      'What should one be careful about when travelling within India?',
      'How to plan a trip to a remote location within India?',
      'How to handle congestion at airports?',
      'Can a Foreigner drive in India?',
    ],
    'Cultural Tips': [
      'What can one expect when visiting homes?',
      'Are there specific ways to greet people in India?',
      'What is appropriate attire in India?',
      'What are the dos and don’ts when visiting religious sites?',
      'How to navigate staring or unwanted attention in public places?',
      'Dos and don’ts of dining',
      'What is the Indian approach to time management?',
      'What is the best approach to negotiations?',
      'How do I manage unsolicited phone calls?',
    ],
    'Banking and Compliance': [
      'What type of Bank account can foreigners open in India?',
      'What documents are required to open an Indian Saving Bank account?',
      'What is a PAN (Permanent Account Number) Card?',
      'What is an AADHAR card?',
      'Recommended Banks?',
      'What is UPI',
      'What is Net banking and Phone banking?',
      'What is RTGS/ IMPS',
    ],
    'Shopping and Lifestyle': [
      'Where should one buy day to day Grocery?',
      'What are the must have Apps while living in India?',
      'Are vegetarian, gluten and vegan options easily available?',
      'How much should one Tipp?',
    ],
    'Education and Schooling': [
      'Which are the recommended international schools in Mumbai',
      'Which are the recommended international schools in Delhi',
      'Which are the recommended international schools in Bengaluru',
      'Which are the recommended international schools in Pune',
      'Which are the recommended international schools in Chennai',
      'Which are the recommended international schools in Hyderabad',
      'What are the various curricula available?',
    ],
  },
  ja: {
    '健康、衛生、安全と防犯': [
      'インドの都市の汚染について何を知っておくべきですか？',
      'インドの過酷な気候（暑さ、モンスーン、冬）にどのように適応できますか？',
      'インドに来たばかりの人が気をつけるべき一般的な病気とは？その予防法は？',
      'インドに移住する前に推奨される予防接種は何ですか？',
      'インドの医療制度はどのようなものですか？',
      'インドの医療施設は信頼できますか？',
      '家庭で医療緊急事態が発生した場合、どのような対策を取るべきですか？',
      'インドに移住する前に健康保険に加入すべきですか？',
      '薬局は簡単に見つかりますか？',
      'インドの水道水は飲用に安全ですか？',
      'ジムやフィットネスセンターは広く利用できますか？',
      '新しい環境で心の健康をどのように保つことができますか？',
      'インドの公共トイレの衛生状態はどうですか？',
      'インドの道路でのさまざまな安全問題とその対処法は？',
      '家庭の安全を確保するにはどうすればよいですか？',
      '家庭内のヘルパーをどのように選び、管理すればよいですか？',
      '近隣の安全について注意すべき点は何ですか？',
      '職人やサービス業者とどう接するべきですか？',
      '業者や職人とやり取りする際の言語の壁をどう乗り越えるか？'
    ],
    '住まいを探す': [
      'インドで住まいを見つけるために利用できるリソースは？',
      '信頼できる不動産仲介業者をどのように選ぶか？',
      '不動産仲介業者に支払うべき手数料は？',
      'オンラインの不動産リスティングやリソースは信頼できますか？',
      'インドの家主の主な責任は何ですか？',
      '借主の主な責任は何ですか？',
      'インドの主要な賃貸契約条件は何ですか？',
      'インドでの住宅賃貸の月額費用はいくらですか？',
      '賃貸に対する税金は何で、どのように支払いますか？',
      '保証金は海外から支払えますか？',
      '保証金の返還は簡単に受けられますか？',
      'バンガロールで外国人に人気のある地域は？',
      'ムンバイで外国人に人気のある地域は？',
      'デリーで外国人に人気のある地域は？',
      'グルグラムで外国人に人気のある地域は？',
      'チェンナイで外国人に人気のある地域は？',
      'ハイデラバードで外国人に人気のある地域は？',
      'プネで外国人に人気のある地域は？'
    ],
    '労働許可、ビザ、その他の手続き': [
      'インドで働くには就労許可が必要ですか？',
      'インドで働く許可を得るのにどのくらい時間がかかりますか？',
      'インドで働くために必要な書類や要件は？',
      'インドに住むために居住許可は必要ですか？',
      '家族もインドで一緒に生活できますか？',
      'インドの雇用ビザの有効期間はどのくらいですか？',
      'インドの就労・居住許可をどのように延長するのですか？',
      '就労許可を延長するために必要な書類は？'
    ],
    '家庭管理のヒント': [
      'インドで家を管理する際の主な課題は何ですか？',
      'インドで家を管理するためのヒントは？',
      'インドの公共サービスはどのように機能しますか？',
      '公共料金の支払い方法は？',
      'インドのごみ処理サービスはどのように機能しますか？',
      '家庭の害虫駆除はどのように管理しますか？',
      '典型的な借主の責任とは？',
      'インドの電圧と電気システムについて何を知っておくべきですか？'
    ],
    '旅行と交通手段': [
      'インドの公共交通機関は整備されていますか？',
      'インド国内を移動する際に注意すべき点は？',
      'インドの遠隔地への旅行をどのように計画しますか？',
      '空港の混雑にどう対応すべきですか？',
      '外国人はインドで運転できますか？'
    ],
    '文化的なヒント': [
      '家庭を訪れる際に期待されることは？',
      'インドで人に挨拶する特別な方法はありますか？',
      'インドで適切な服装とは？',
      '宗教施設を訪れる際のマナーや注意点は？',
      '公共の場での視線や好ましくない注目をどうかわすか？',
      '食事のマナーとタブーは？',
      '時間管理に対するインド人の考え方は？',
      '交渉における最善のアプローチとは？',
      '迷惑電話への対応方法は？'
    ],
    '銀行とコンプライアンス': [
      '外国人がインドで開設できる銀行口座の種類は？',
      'インドの普通預金口座を開設するために必要な書類は？',
      'PAN（納税者番号）カードとは？',
      'AADHARカードとは？',
      'おすすめの銀行は？',
      'UPIとは？',
      'ネットバンキングおよび電話バンキングとは？',
      'RTGS / IMPSとは？'
    ],
    '買い物とライフスタイル': [
      '日用品の食料品はどこで買うべきですか？',
      'インド生活で必須のアプリは何ですか？',
      'ベジタリアン、グルテンフリー、ヴィーガンの選択肢は簡単に見つかりますか？',
      'チップはいくら渡すべきですか？'
    ],
    '教育と学校教育': [
      'ムンバイでおすすめのインターナショナルスクールは？',
      'デリーでおすすめのインターナショナルスクールは？',
      'バンガロールでおすすめのインターナショナルスクールは？',
      'プネでおすすめのインターナショナルスクールは？',
      'チェンナイでおすすめのインターナショナルスクールは？',
      'ハイデラバードでおすすめのインターナショナルスクールは？',
      '利用可能な教育カリキュラムは？'
    ]
  },
  de: {
    'Gesundheit, Hygiene, Sicherheit und Schutz': [
      'Was sollte ich über die Umweltverschmutzung in indischen Städten wissen?',
      'Wie kann ich mich an extreme Wetterbedingungen in Indien (Hitze, Monsun, Winter) anpassen?',
      'Welche häufigen Krankheiten sollten Neuankömmlinge in Indien kennen? Welche Präventionsmaßnahmen werden empfohlen?',
      'Welche Impfungen werden vor einem Umzug nach Indien empfohlen?',
      'Wie ist das Gesundheitssystem in Indien aufgebaut?',
      'Sind die medizinischen Einrichtungen in Indien zuverlässig?',
      'Welche Maßnahmen sollten bei einem medizinischen Notfall zu Hause ergriffen werden?',
      'Sollte man vor dem Umzug nach Indien eine Krankenversicherung abschließen?',
      'Sind Apotheken leicht zugänglich?',
      'Ist Leitungswasser in Indien trinkbar?',
      'Sind Fitnessstudios und Sportzentren weit verbreitet?',
      'Wie kann ich mein mentales Wohlbefinden in einer neuen Umgebung aufrechterhalten?',
      'Wie hygienisch sind öffentliche Toilettenanlagen in Indien?',
      'Welche Sicherheitsprobleme gibt es auf indischen Straßen und wie geht man damit um?',
      'Wie kann man die Sicherheit zu Hause gewährleisten?',
      'Wie wählt und verwaltet man Haushaltshilfen?',
      'Worauf sollte man in Bezug auf die Sicherheit der Nachbarschaft achten?',
      'Wie geht man mit Handwerkern und anderen Dienstleistern um?',
      'Wie überwindet man Sprachbarrieren im Umgang mit Anbietern und Handwerkern?'
    ],
    'Eine Unterkunft finden': [
      'Welche Ressourcen stehen zur Verfügung, um in Indien ein Zuhause zu finden?',
      'Wie wählt man einen zuverlässigen Immobilienmakler aus?',
      'Welche Provisionen müssen an Immobilienmakler gezahlt werden?',
      'Sind Online-Immobilienanzeigen und -portale zuverlässig?',
      'Was sind die Hauptverantwortlichkeiten eines indischen Vermieters?',
      'Was sind die Hauptverantwortlichkeiten eines Mieters?',
      'Was sind die wichtigsten Mietvertragsbedingungen in Indien?',
      'Wie hoch sind die monatlichen Mietkosten in Indien?',
      'Welche Steuern fallen auf Mieten an und wie werden sie gezahlt?',
      'Kann die Kaution aus dem Ausland gezahlt werden?',
      'Ist es einfach, die Kaution zurückzubekommen?',
      'Welche Stadtviertel in Bengaluru sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Mumbai sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Delhi sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Gurugram sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Chennai sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Hyderabad sind bei Ausländern beliebt?',
      'Welche Stadtviertel in Pune sind bei Ausländern beliebt?'
    ],
    'Arbeitserlaubnis, Visum und andere Auflagen': [
      'Benötige ich eine Arbeitserlaubnis, um in Indien arbeiten zu können?',
      'Wie lange dauert es, eine Arbeitserlaubnis für Indien zu erhalten?',
      'Welche Dokumente und Anforderungen müssen erfüllt sein, um in Indien arbeiten zu dürfen?',
      'Benötige ich eine Aufenthaltserlaubnis, um in Indien leben zu können?',
      'Dürfen meine Familienangehörigen mit mir in Indien leben?',
      'Wie lange ist ein indisches Arbeitsvisum gültig?',
      'Wie kann man eine indische Arbeits- und Aufenthaltserlaubnis verlängern?',
      'Welche Dokumente sind für die Verlängerung einer Arbeitserlaubnis erforderlich?'
    ],
    'Tipps zur Haushaltsführung': [
      'Welche Hauptprobleme treten bei der Verwaltung eines Haushalts in Indien auf?',
      'Gibt es Tipps zur Haushaltsführung in Indien?',
      'Wie funktionieren Versorgungsdienste in Indien?',
      'Wie bezahlt man Versorgungsrechnungen?',
      'Wie funktioniert die Müllentsorgung in Indien?',
      'Wie kann man Schädlingsbekämpfung im Haus organisieren?',
      'Was sind typische Pflichten eines Mieters?',
      'Was sollte ich über Stromspannung und Elektrik in Indien wissen?'
    ],
    'Reise und Transport': [
      'Ist das öffentliche Verkehrssystem in Indien gut ausgebaut?',
      'Worauf sollte man achten, wenn man innerhalb Indiens reist?',
      'Wie plant man eine Reise zu einem abgelegenen Ort in Indien?',
      'Wie geht man mit Staus an Flughäfen um?',
      'Dürfen Ausländer in Indien Auto fahren?'
    ],
    'Kulturelle Tipps': [
      'Was kann man beim Besuch von Privatwohnungen erwarten?',
      'Gibt es bestimmte Begrüßungsformen in Indien?',
      'Welche Kleidung ist in Indien angebracht?',
      'Was sollte man beim Besuch religiöser Stätten beachten?',
      'Wie geht man mit unangenehmem Starren oder unerwünschter Aufmerksamkeit in der Öffentlichkeit um?',
      'Verhaltensregeln beim Essen – was ist erlaubt und was nicht?',
      'Wie steht man in Indien zum Zeitmanagement?',
      'Was ist der beste Weg für Verhandlungen?',
      'Wie gehe ich mit unerwünschten Telefonanrufen um?'
    ],
    'Bankwesen und Vorschriften': [
      'Welche Art von Bankkonto können Ausländer in Indien eröffnen?',
      'Welche Dokumente werden für die Eröffnung eines indischen Sparkontos benötigt?',
      'Was ist eine PAN (Permanent Account Number) Karte?',
      'Was ist eine AADHAR-Karte?',
      'Welche Banken werden empfohlen?',
      'Was ist UPI?',
      'Was ist Online- und Telefonbanking?',
      'Was ist RTGS/IMPS?'
    ],
    'Einkaufen und Lebensstil': [
      'Wo sollte man alltägliche Lebensmittel einkaufen?',
      'Welche Apps sind für das Leben in Indien unverzichtbar?',
      'Sind vegetarische, glutenfreie und vegane Optionen leicht verfügbar?',
      'Wie viel Trinkgeld sollte man geben?'
    ],
    'Bildung und Schulwesen': [
      'Welche internationalen Schulen werden in Mumbai empfohlen?',
      'Welche internationalen Schulen werden in Delhi empfohlen?',
      'Welche internationalen Schulen werden in Bengaluru empfohlen?',
      'Welche internationalen Schulen werden in Pune empfohlen?',
      'Welche internationalen Schulen werden in Chennai empfohlen?',
      'Welche internationalen Schulen werden in Hyderabad empfohlen?',
      'Welche Lehrpläne stehen zur Verfügung?'
    ]
  },
  fr: {
    'Santé, hygiène, sécurité et sûreté': [
      'Que dois-je savoir sur la pollution dans les villes indiennes ?',
      'Comment puis-je m’adapter aux conditions météorologiques extrêmes en Inde (chaleur, moussons, hivers) ?',
      'Quelles sont les maladies courantes auxquelles les nouveaux arrivants en Inde doivent faire attention ? Quelles sont les techniques de prévention recommandées ?',
      'Quels vaccins sont recommandés avant de déménager en Inde ?',
      'Comment fonctionne le système de santé en Inde ?',
      'Les établissements médicaux en Inde sont-ils fiables ?',
      'Quelles mesures faut-il prendre en cas d’urgence médicale à domicile ?',
      'Faut-il souscrire une assurance santé avant de déménager en Inde ?',
      'Les pharmacies sont-elles facilement accessibles ?',
      'L’eau du robinet est-elle potable en Inde ?',
      'Les salles de sport et centres de remise en forme sont-ils largement disponibles ?',
      'Comment puis-je maintenir mon bien-être mental dans un nouvel environnement ?',
      'Quel est le niveau d’hygiène des toilettes publiques en Inde ?',
      'Quels sont les principaux problèmes de sécurité sur les routes indiennes et comment les gérer ?',
      'Comment assurer la sécurité de son domicile ?',
      'Comment sélectionner et gérer l’aide domestique ?',
      'À quoi faut-il faire attention en matière de sécurité dans le voisinage ?',
      'Comment gérer les artisans et autres prestataires de services ?',
      'Comment surmonter les barrières linguistiques lors des interactions avec les vendeurs et artisans ?'
    ],
    'Trouver un logement': [
      'Quelles sont les ressources disponibles pour trouver un logement en Inde ?',
      'Comment choisir un agent immobilier fiable ?',
      'Quelles commissions doivent être versées aux agents immobiliers ?',
      'Les annonces et ressources immobilières en ligne sont-elles fiables ?',
      'Quelles sont les principales responsabilités d’un propriétaire indien ?',
      'Quelles sont les principales responsabilités d’un locataire ?',
      'Quels sont les principaux termes d’un bail en Inde ?',
      'Quel est le coût mensuel moyen d’un logement en Inde ?',
      'Quelles sont les taxes applicables au bail et comment sont-elles payées ?',
      'La caution peut-elle être payée depuis l’étranger ?',
      'Est-il facile d’obtenir le remboursement de la caution ?',
      'Quels sont les quartiers préférés des étrangers à Bangalore ?',
      'Quels sont les quartiers préférés des étrangers à Mumbai ?',
      'Quels sont les quartiers préférés des étrangers à Delhi ?',
      'Quels sont les quartiers préférés des étrangers à Gurugram ?',
      'Quels sont les quartiers préférés des étrangers à Chennai ?',
      'Quels sont les quartiers préférés des étrangers à Hyderabad ?',
      'Quels sont les quartiers préférés des étrangers à Pune ?'
    ],
    'Permis de travail, visa et autres formalités': [
      'Ai-je besoin d’un permis de travail pour exercer une activité en Inde ?',
      'Combien de temps faut-il pour obtenir une autorisation de travail en Inde ?',
      'Quels documents et conditions sont requis pour travailler en Inde ?',
      'Ai-je besoin d’un permis de résidence pour vivre en Inde ?',
      'Ma famille pourra-t-elle vivre avec moi en Inde ?',
      'Quelle est la durée de validité du visa de travail indien ?',
      'Comment prolonger un permis de travail et de résidence indien ?',
      'Quels documents sont nécessaires pour prolonger un permis de travail ?'
    ],
    'Conseils pour la gestion du domicile': [
      'Quels sont les principaux défis liés à la gestion d’un foyer en Inde ?',
      'Avez-vous des conseils pour gérer une maison en Inde ?',
      'Comment fonctionnent les services publics en Inde ?',
      'Comment payer les factures de services publics ?',
      'Comment fonctionne le service de gestion des déchets en Inde ?',
      'Comment gérer la lutte antiparasitaire à la maison ?',
      'Quelles sont les responsabilités typiques du locataire ?',
      'Que faut-il savoir sur la tension et les systèmes électriques en Inde ?'
    ],
    'Voyage et transport': [
      'Le système de transport public est-il bien développé en Inde ?',
      'À quoi faut-il faire attention lors des déplacements en Inde ?',
      'Comment organiser un voyage dans une région reculée en Inde ?',
      'Comment gérer les embouteillages dans les aéroports ?',
      'Un étranger peut-il conduire en Inde ?'
    ],
    'Conseils culturels': [
      'À quoi faut-il s’attendre lorsqu’on visite une maison ?',
      'Existe-t-il des façons spécifiques de saluer les gens en Inde ?',
      'Quelle tenue est appropriée en Inde ?',
      'Quelles sont les règles à suivre dans les lieux religieux ?',
      'Comment gérer les regards insistants ou l’attention non désirée dans les lieux publics ?',
      'Que faire et ne pas faire à table ?',
      'Quelle est l’approche indienne de la gestion du temps ?',
      'Quelle est la meilleure approche pour négocier ?',
      'Comment gérer les appels téléphoniques indésirables ?'
    ],
    'Services bancaires et conformité': [
      'Quel type de compte bancaire un étranger peut-il ouvrir en Inde ?',
      'Quels documents sont nécessaires pour ouvrir un compte bancaire en Inde ?',
      'Qu’est-ce qu’une carte PAN (numéro d’identification fiscale permanent) ?',
      'Qu’est-ce qu’une carte AADHAR ?',
      'Quelles banques sont recommandées ?',
      'Qu’est-ce que l’UPI ?',
      'Qu’est-ce que la banque en ligne et la banque par téléphone ?',
      'Qu’est-ce que le RTGS/IMPS ?'
    ],
    'Achats et mode de vie': [
      'Où acheter les produits d’épicerie du quotidien ?',
      'Quelles sont les applications indispensables en Inde ?',
      'Les options végétariennes, sans gluten et végétaliennes sont-elles facilement disponibles ?',
      'Combien faut-il donner de pourboire ?'
    ],
    'Éducation et scolarité': [
      'Quelles sont les écoles internationales recommandées à Mumbai ?',
      'Quelles sont les écoles internationales recommandées à Delhi ?',
      'Quelles sont les écoles internationales recommandées à Bangalore ?',
      'Quelles sont les écoles internationales recommandées à Pune ?',
      'Quelles sont les écoles internationales recommandées à Chennai ?',
      'Quelles sont les écoles internationales recommandées à Hyderabad ?',
      'Quels sont les différents programmes scolaires disponibles ?'
    ]
  },
  es: {
    'Salud, higiene, seguridad y protección': [
      '¿Qué debo saber sobre la contaminación en las ciudades indias?',
      '¿Cómo puedo adaptarme a las condiciones climáticas extremas en India (calor, monzones, inviernos)?',
      '¿Cuáles son las enfermedades comunes que deben conocer los recién llegados a India? ¿Cuáles son las técnicas de prevención recomendadas?',
      '¿Qué vacunas se recomiendan antes de mudarse a India?',
      '¿Cómo es el sistema de salud en India?',
      '¿Son fiables las instalaciones médicas en India?',
      '¿Qué medidas se deben tomar en caso de una emergencia médica en casa?',
      '¿Debería contratar un seguro médico antes de mudarse a India?',
      '¿Las farmacias están fácilmente disponibles?',
      '¿El agua del grifo es segura para beber en India?',
      '¿Están ampliamente disponibles los gimnasios y centros de fitness?',
      '¿Cómo puedo mantener el bienestar mental en un nuevo entorno?',
      '¿Qué tan higiénicos son los baños públicos en India?',
      '¿Cuáles son los diferentes problemas de seguridad en las carreteras indias y cómo afrontarlos?',
      '¿Cómo garantizar la seguridad del hogar?',
      '¿Cómo seleccionar y gestionar la ayuda doméstica?',
      '¿A qué debo prestar atención en cuanto a la seguridad del vecindario?',
      '¿Cómo tratar con técnicos y otros proveedores de servicios?',
      '¿Cómo superar las barreras del idioma al tratar con proveedores y técnicos?'
    ],
    'Buscar una vivienda': [
      '¿Qué recursos están disponibles para encontrar una vivienda en India?',
      '¿Cómo seleccionar un agente inmobiliario confiable?',
      '¿Qué comisiones se deben pagar a los agentes inmobiliarios?',
      '¿Son fiables los listados y recursos inmobiliarios en línea?',
      '¿Cuáles son las principales responsabilidades de un propietario en India?',
      '¿Cuáles son las principales responsabilidades de un inquilino?',
      '¿Cuáles son los principales términos de arrendamiento en India?',
      '¿Cuál es el costo mensual de alquilar una vivienda en India?',
      '¿Qué impuestos se aplican al arrendamiento y cómo se pagan?',
      '¿Se puede pagar el depósito de seguridad desde el extranjero?',
      '¿Es fácil recuperar el depósito de seguridad?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Bangalore?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Mumbai?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Delhi?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Gurugram?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Chennai?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Hyderabad?',
      '¿Cuáles son las comunidades preferidas por los extranjeros en Pune?'
    ],
    'Permiso de trabajo, visado y otros trámites': [
      '¿Necesito un permiso de trabajo para poder trabajar en India?',
      '¿Cuánto tiempo se tarda en obtener permiso para trabajar en India?',
      '¿Qué documentos y requisitos se deben cumplir para trabajar en India?',
      '¿Necesito un permiso de residencia para vivir en India?',
      '¿Pueden mis familiares vivir conmigo en India?',
      '¿Cuánto tiempo es válido el visado de trabajo para India?',
      '¿Cómo se amplía un permiso de trabajo y residencia en India?',
      '¿Qué documentos se requieren para ampliar el permiso de trabajo?'
    ],
    'Consejos para la gestión del hoga': [
      '¿Cuáles son los principales problemas al gestionar una casa en India?',
      '¿Algunos consejos para gestionar una casa en India?',
      '¿Cómo funcionan los servicios públicos en India?',
      '¿Cómo pagar las facturas de servicios públicos?',
      '¿Cómo funciona el servicio de recogida de basura en India?',
      '¿Cómo gestionar el control de plagas en casa?',
      '¿Cuáles son las responsabilidades típicas de un inquilino?',
      '¿Qué debo saber sobre el voltaje y los sistemas eléctricos en India?'
    ],
    'Viajes y transporte': [
      '¿Está bien establecido el sistema de transporte público en India?',
      '¿Qué precauciones se deben tener al viajar dentro de India?',
      '¿Cómo planificar un viaje a una ubicación remota dentro de India?',
      '¿Cómo gestionar la congestión en los aeropuertos?',
      '¿Puede un extranjero conducir en India?'
    ],
    'Consejos culturales': [
      '¿Qué se puede esperar al visitar hogares en India?',
      '¿Existen formas específicas de saludar en India?',
      '¿Cuál es la vestimenta adecuada en India?',
      '¿Cuáles son las normas a seguir al visitar sitios religiosos?',
      '¿Cómo afrontar las miradas o la atención no deseada en lugares públicos?',
      'Modales y normas en la mesa',
      '¿Cuál es la actitud india hacia la gestión del tiempo?',
      '¿Cuál es la mejor forma de negociar?',
      '¿Cómo gestiono las llamadas telefónicas no deseadas?'
    ],
    'Banca y cumplimiento': [
      '¿Qué tipo de cuenta bancaria pueden abrir los extranjeros en India?',
      '¿Qué documentos se necesitan para abrir una cuenta de ahorro en India?',
      '¿Qué es una tarjeta PAN (número de cuenta permanente)?',
      '¿Qué es una tarjeta AADHAR?',
      '¿Qué bancos se recomiendan?',
      '¿Qué es UPI?',
      '¿Qué es la banca en línea y telefónica?',
      '¿Qué es RTGS / IMPS?'
    ],
    'Compras y estilo de vida': [
      '¿Dónde comprar comestibles del día a día?',
      '¿Cuáles son las aplicaciones imprescindibles en India?',
      '¿Son fácilmente accesibles las opciones vegetarianas, sin gluten y veganas?',
      '¿Cuánto se debe dejar de propina?'
    ],
    'Educación y escolarización': [
      '¿Cuáles son las escuelas internacionales recomendadas en Mumbai?',
      '¿Cuáles son las escuelas internacionales recomendadas en Delhi?',
      '¿Cuáles son las escuelas internacionales recomendadas en Bangalore?',
      '¿Cuáles son las escuelas internacionales recomendadas en Pune?',
      '¿Cuáles son las escuelas internacionales recomendadas en Chennai?',
      '¿Cuáles son las escuelas internacionales recomendadas en Hyderabad?',
      '¿Qué programas educativos están disponibles?'
    ]
  },
  it: {
    'Salute, igiene, sicurezza e protezione': [
      'Cosa dovrei sapere sull’inquinamento nelle città indiane?',
      'Come posso adattarmi alle condizioni climatiche estreme in India (caldo, monsoni, inverni)?',
      'Quali sono i disturbi comuni a cui devono fare attenzione i nuovi arrivati in India? Quali sono le tecniche di prevenzione consigliate?',
      'Quali vaccinazioni sono raccomandate prima di trasferirsi in India?',
      'Com’è il sistema sanitario in India?',
      'Le strutture mediche in India sono affidabili?',
      'Quali misure bisogna adottare in caso di emergenza medica a casa?',
      'È consigliabile stipulare un’assicurazione sanitaria prima di trasferirsi in India?',
      'Le farmacie sono facilmente accessibili?',
      'L’acqua del rubinetto è sicura da bere in India?',
      'Le palestre e i centri fitness sono ampiamente disponibili?',
      'Come posso mantenere il benessere mentale in un nuovo ambiente?',
      'Quanto sono igienici i bagni pubblici in India?',
      'Quali sono i problemi di sicurezza sulle strade indiane e come affrontarli?',
      'Come garantire la sicurezza domestica?',
      'Come selezionare e gestire il personale domestico?',
      'Cosa bisogna sapere sulla sicurezza del quartiere?',
      'Come gestire artigiani e fornitori di servizi?',
      'Come superare le barriere linguistiche quando si interagisce con fornitori e artigiani?'
    ],
    'Trovare una casa': [
      'Quali risorse sono disponibili per trovare una casa in India?',
      'Come scegliere un agente immobiliare affidabile?',
      'Quali commissioni devono essere pagate agli agenti immobiliari?',
      'Gli annunci e le risorse immobiliari online sono affidabili?',
      'Quali sono le principali responsabilità di un proprietario indiano?',
      'Quali sono le principali responsabilità di un inquilino?',
      'Quali sono i principali termini del contratto di locazione in India?',
      'Qual è il costo mensile per affittare una casa in India?',
      'Quali tasse si applicano all’affitto e come vengono pagate?',
      'È possibile pagare il deposito cauzionale dall’estero?',
      'È facile ottenere il rimborso del deposito cauzionale?',
      'Quali sono le comunità preferite dagli stranieri a Bangalore?',
      'Quali sono le comunità preferite dagli stranieri a Mumbai?',
      'Quali sono le comunità preferite dagli stranieri a Delhi?',
      'Quali sono le comunità preferite dagli stranieri a Gurugram?',
      'Quali sono le comunità preferite dagli stranieri a Chennai?',
      'Quali sono le comunità preferite dagli stranieri a Hyderabad?',
      'Quali sono le comunità preferite dagli stranieri a Pune?'
    ],
    'Permesso di lavoro, visto e altri adempimenti': [
      'Ho bisogno di un permesso di lavoro per lavorare in India?',
      'Quanto tempo ci vuole per ottenere il permesso di lavorare in India?',
      'Quali documenti e requisiti sono necessari per lavorare in India?',
      'Ho bisogno di un permesso di soggiorno per vivere in India?',
      'I miei familiari possono vivere con me in India?',
      'Per quanto tempo è valido il visto di lavoro per l’India?',
      'Come si estende un permesso di lavoro e soggiorno in India?',
      'Quali documenti sono necessari per prorogare il permesso di lavoro?'
    ],
    'Consigli per la gestione della casa': [
      'Quali sono i principali problemi nella gestione di una casa in India?',
      'Qualche consiglio per gestire una casa in India?',
      'Come funzionano le utenze in India?',
      'Come si pagano le bollette?',
      'Come funziona il servizio di raccolta rifiuti in India?',
      'Come gestire il controllo dei parassiti in casa?',
      'Quali sono le responsabilità tipiche di un inquilino?',
      'Cosa devo sapere sulla tensione e i sistemi elettrici in India?'
    ],
    'Viaggi e trasporti': [
      'Il sistema di trasporto pubblico è ben sviluppato in India?',
      'A cosa bisogna fare attenzione quando si viaggia in India?',
      'Come pianificare un viaggio in una località remota in India?',
      'Come affrontare la congestione negli aeroporti?',
      'Uno straniero può guidare in India?'
    ],
    'Suggerimenti culturali': [
      'Cosa ci si può aspettare quando si visitano le case in India?',
      'Esistono modi specifici per salutare in India?',
      'Qual è l’abbigliamento appropriato in India?',
      'Quali sono le regole da seguire nei siti religiosi?',
      'Come gestire gli sguardi o l’attenzione indesiderata in luoghi pubblici?',
      'Buone maniere a tavola: cosa fare e cosa evitare',
      'Qual è l’approccio indiano alla gestione del tempo?',
      'Qual è il modo migliore per negoziare?',
      'Come gestire le chiamate telefoniche indesiderate?'
    ],
    'Bancario e conformità': [
      'Che tipo di conto bancario possono aprire gli stranieri in India?',
      'Quali documenti sono richiesti per aprire un conto di risparmio in India?',
      'Cos’è una carta PAN (codice identificativo fiscale permanente)?',
      'Cos’è una carta AADHAR?',
      'Quali banche sono consigliate?',
      'Cos’è UPI?',
      'Cos’è l’online banking e il phone banking?',
      'Cos’è RTGS / IMPS?'
    ],
    'Shopping e stile di vita': [
      'Dove acquistare generi alimentari di uso quotidiano?',
      'Quali sono le app essenziali per vivere in India?',
      'Le opzioni vegetariane, senza glutine e vegane sono facilmente reperibili?',
      'Quanto si dovrebbe lasciare di mancia?'
    ],
    'Istruzione e scuola': [
      'Quali scuole internazionali sono consigliate a Mumbai?',
      'Quali scuole internazionali sono consigliate a Delhi?',
      'Quali scuole internazionali sono consigliate a Bangalore?',
      'Quali scuole internazionali sono consigliate a Pune?',
      'Quali scuole internazionali sono consigliate a Chennai?',
      'Quali scuole internazionali sono consigliate a Hyderabad?',
      'Quali programmi scolastici sono disponibili?'
    ]
  }
};

const FAQ = ({ onClose, onSelectQuestion, selectedLang }) => {
  const [expandedCategory, setExpandedCategory] = useState(null);

  const langCode = selectedLang?.code || 'en';
  const languageFaqData = faqData[langCode] || faqData['en'];

  const toggleCategory = (category) => {
    setExpandedCategory(expandedCategory === category ? null : category);
  };

  return (
    <div className="bg-white">
      {/* <div className="flex items-center justify-between mb-4">
        <h2 className="text-xl font-bold text-gray-800">
          Frequently Asked Questions
        </h2>
        <button
          onClick={onClose}
          className="text-gray-500 hover:text-red-500 transition-colors duration-200"
          aria-label="Close FAQ"
        >
          <i className="fa-regular fa-circle-xmark text-xl"></i>
        </button>
      </div> */}
      {/* Your FAQ content goes here */}
      {Object.entries(languageFaqData)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([category, questions], index, arr) => {
          const isExpanded = expandedCategory === category;
          // const isAboveExpanded = expandedCategory === arr[index + 1]?.[0];

          return (
            <div
              key={category}
              className={`category-wrapper border-b-[1px] border-[#949699] ${
                isExpanded ? 'no-border' : ''
              }`}
            >
              <div className={`mx-3 ${isExpanded ? 'expanded-category' : ''}`}>
                <div
                  className="cursor-pointer pt-3 pb-[17px]  pr-2 flex justify-between items-center"
                  onClick={() => toggleCategory(category)}
                >
                  <span className="faq-category-title">{category}</span>
                  <i
                    className={`fas fa-chevron-${
                      isExpanded ? 'up' : 'down'
                    } text-gray-600`}
                  ></i>
                </div>
                {isExpanded && (
                  <ul className="px-6">
                    {questions.map((q, idx) => (
                      <li
                        key={idx}
                        onClick={() => onSelectQuestion(q)}
                        className="cursor-pointer faq-questions"
                      >
                        • {q}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default FAQ;
